const DRAFT = 'draft';
const IN_REVIEW = 'in_review';
const LOCKED = 'locked';

export default class BudgetStatus {
    static get DRAFT() { return DRAFT; }

    static get IN_REVIEW() { return IN_REVIEW; }

    static get LOCKED() { return LOCKED; }
}
